import {z} from 'zod';
import { variantSchema } from '@/product/types';

export const imageSchema = z.object({
    alt: z.string().nullable(),
    url: z.string()
})

export type ImageState = z.infer<typeof imageSchema>;

const giftSchema = z.object({
    description: z.string(),
    discount_code: z.string(),
    gift_variant: variantSchema.nullable(),
    image: imageSchema,
    minimum_load_to_apply: z.number().nullable(),
    title: z.string()
})

export type GiftState = z.infer<typeof giftSchema>;

export const otpSettingsSchema = z.object({
    msg_color: z.string(),
    msg_text: z.string(),
    subtitle: z.string(),
    variants: z.array(variantSchema),
    discount_code: z.string(),
    carousel_images: imageSchema.array(),
    hero_images: imageSchema.array(),
    gifts: z.array(giftSchema),
    cta_button_label: z.string().nullable(),
})

export type OtpSettings = z.infer<typeof otpSettingsSchema>;
 
export const otpSettingsArrSchema = z.array(otpSettingsSchema)

export type OtpSettingsArr = z.infer<typeof otpSettingsArrSchema>;